import { useEffect } from "react";

let confirmationMessage: string | null = null;
let navigationAllowed = false;

// https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#examples
const beforeUnloadListener = (event) => {
  if (navigationAllowed) {
    return;
  }

  event.preventDefault();
  return (event.returnValue = "");
};

export function getConfirmationMessage() {
  return confirmationMessage;
}

export function allowNavigation() {
  navigationAllowed = true;
}

export function disallowNavigation() {
  navigationAllowed = false;
}

function enableInterceptor(message) {
  confirmationMessage = message;
  window.addEventListener("beforeunload", beforeUnloadListener, {
    capture: true,
  });
}

function disableInterceptor() {
  confirmationMessage = null;
  navigationAllowed = false;
  removeEventListener("beforeunload", beforeUnloadListener, { capture: true });
}

export default function useInterceptorPrompt(message: string, when = true) {
  useEffect(() => {
    if (when && !window.isApp) {
      enableInterceptor(message);
    } else {
      disableInterceptor();
    }

    return disableInterceptor;
  }, [message, when]);
}

if (typeof window !== "undefined") {
  window.InterceptorPrompt = {
    allowNavigation,
    disallowNavigation,
    getConfirmationMessage,
  };
}
